import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mitteilungen-gesendet-gruppiert';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenMitteilungenGesendetGruppiertEffects {

    MitteilungenGesendetGruppiert$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MITTEILUNGEN_GESENDET_GRUPPIERT),
        mergeMap((x: ac.GetMitteilungenGesendetGruppiertAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMitteilungenGesendetGruppiert(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetMitteilungenGesendetGruppiertErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMitteilungenGesendetGruppiertFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungenQueryService);
        }
        return this.service;
    }
}
